import { TextButton } from './text-button.model';
import { UrlButton } from './url-button.model';
import { URLMarker } from './url-maker.model';

export class Text {
  urls: URLMarker[] = [];
  url_buttons?: UrlButton[];
  parts?: { text: string; ariaHidden?: boolean }[];
  buttons?: TextButton[];
  constructor(public content: string) {}
}
